type LoadingCellProps = {
    colSpan?: number;
};

function LoadingCell({ colSpan = 1 }: LoadingCellProps): JSX.Element {
    return (
        <td className="py-1" colSpan={colSpan}>
            <div className="bg-gray-100 animate-pulse h-8 rounded-md"></div>
        </td>
    );
}

export default LoadingCell;
